// extracted by mini-css-extract-plugin
export default {"photo-gallery-item":"PhotoGalleryItem_photo-gallery-item__W7Z60","photo-gallery-item__image":"PhotoGalleryItem_photo-gallery-item__image__AV9O3"};